module.exports = __webpack_public_path__ + "static/media/med.9930adce.svg";